import React, { useEffect } from 'react';
import { StyledDetailJob } from './StyledDetailJob';
import {gsap} from 'gsap';

const DetailJob = ({ details, toggleFn }) => {

  
  const copyClipboard = (event) => {
    const body = document.querySelector('body');
    const paragraph = event.currentTarget;
    const area = document.createElement('textarea');
    body.appendChild(area);

    const TL = gsap.timeline();
    TL
    .to('.copy--clipboard .copied', {opacity: 1})
    .to('.copy--clipboard .copied', {opacity: 0}, '+=1')
    area.value = paragraph.innerText;
    area.select();
    document.execCommand('copy');

    body.removeChild(area);
  }

  

  return (
    <React.Fragment>
      {
       
          <StyledDetailJob >
            <div className="job--title-wrap">
              <h4 className="md--title">
                {
                  details.job_title
                }
              </h4>
              <div className="job-location-wrap">
                  <img src="/location.svg" />
                  <p className="preset-12">{details.location}</p>
                  <div className="copy--clipboard">
                    <p className="hidden" onClick={ (e) => copyClipboard(e)}>
                      {window.location.href}
                    </p>
                    <img src="/link-icon.svg" />
                    <div className="copied">
                      Copied
                    </div>
                  </div>
              </div>
            </div>
            
            <div className="job--body-wrap">
              <div className="job--intro">
                <p className="preset-10">
                  {
                    details.intro_text
                  }
                </p>
                <div onClick={() => toggleFn(true)} target="_blank" className="apply-wrap">
                  <p className="preset-10">Apply</p>
                  <img src="/arrow-up-right.svg" />
                </div>
              </div>
              
              <div className="job--description">
                <h6 className="md--title">Main tasks</h6>
                {
                  details.main_tasks.map((key, index) => {
                    return <p className="preset-10 list-tasks" key={index}>{key}</p>
                  })
                }
                <h6 className="md--title">Requirements</h6>
                {
                  details.main_requirements.map((key, index) => {
                    return <p className="preset-10 list-tasks" key={index}>{key}</p>
                  })
                }
              </div>
              
            </div>
            
          </StyledDetailJob>
          
      }
    </React.Fragment>
  );
};


export default DetailJob;
